import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    // backgroundColor: '#ffeffa',

    alignItems: 'center',
    padding: `${scale.s} ${scale.xs} ${scale.l}`,
  },

  blockHeading: {
    fontWeight: '700',
  },

  blockDescription: {
    margin: '0 !important',
  },

  categoryHeading: {
    fontWeight: '700',
    marginBottom: '0.3rem !important',
    fontSize: '2rem',
    display: 'flex',
    alignItems: 'center',

    [media.s.down]: {
      fontSize: '1.6rem',
    },
  },

  dealsContainer: {
    ...layouts.column,
  },

  memberDealCategoryContainer: {
    ...layouts.column,
  },

  categoryDealsContainer: {
    ...layouts.row,
    borderTop: `2px solid ${colors.black}`,
    alignItems: 'stretch',
    flexWrap: 'wrap',
    gap: '0.5rem',
    margin: `0 0 ${scale.l} 0`,
  },

  dealContainer: {
    ...layouts.column,
    padding: `${scale.s} 0 0`,
    gap: '0.25rem',

    [media.s.down]: {
      flex: `1 0 calc(${100 / 1}% - 0.5rem)`,
      maxWidth: `calc(${100 / 1}% - 0.5rem)`,
    },

		[media.m.up]: {
      flex: `1 0 calc(${100 / 2}% - 0.5rem)`,
      maxWidth: `calc(${100 / 2}% - 0.5rem)`,
    },

    [media.l.up]: {
      flex: `1 0 calc(${100 / 3}% - 0.5rem)`,
      maxWidth: `calc(${100 / 3}% - 0.5rem)`,
    },

    h3: {
      fontSize: '1.1rem',
      // fontWeight: '700',
      margin: `0 0 ${scale.xxs} !important`,
      // color: colors.sas.primary,
      textDecoration: 'underline',
      cursor: 'pointer',
    },

    '> div': {
      margin: '0 !important',
      fontSize: '0.9rem',
      flexGrow: '1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
    },
  },

  dealImage: {
		flex: '0 0 250px',
		maxHeight: '250px',
		overflow: 'hidden',
    // flex: '0 0 100px',
    // maxWidth: '100px',

    '> img': {
      width: 'auto',
      height: '250px',
			objectFit: 'cover',
			maxHeight: '250px',
    },
  },

  dealExcerpt: {
    flexGrow: '1',
  },

  dealCompany: {
    // fontWeight: '700',
  },

  dealModalTitleContainer: {
    ...layouts.row,
    alignItems: 'center',
    justifyContent: 'stretch',
    backgroundColor: colors.sas.primary,
    padding: `0`,
  },

  modalTabs: {
    ...layouts.row,
    flexGrow: '1',
    alignItems: 'stretch',
  },

  tab: {
    display: 'flex',
    alignItems: 'center',
    padding: `${scale.s} ${scale.s}`,
    textTransform: 'uppercase',
    fontWeight: '700',
    fontSize: '1.1rem',
    color: colors.white,
    cursor: 'pointer',
  },

  activeTab: {
    backgroundColor: colors.white,
    color: colors.sas.primary,
  },

  modalCloseIcon: {
    cursor: 'pointer',
    flex: `0 0 20px`,
    fontSize: `2.5em !important`,
    color: `${colors.white} !important`,
    margin: `0 ${scale.s} 0 0`,
  },

  dealModalContentContainer: {
    ...layouts.column,
    padding: '0',
    backgroundColor: colors.white,
    color: colors.black,
    height: `80vh !important`,
    overflowY: 'auto',
    alignItems: 'stretch',

    [media.l.up]: {
      ...layouts.row,
      alignItems: 'stretch',
    },
  },

  content: {
    ...layouts.column,
    padding: `${scale.s} ${scale.m}`,
    flex: `0 0 100%`,
    maxWidth: `100%`,

    [media.l.up]: {
      flex: `0 0 50%`,
      maxWidth: `50%`,
    },
  },

  contentLeft: {
    justifyContent: 'flex-start',
  },

  modalDealTeaser: {
    marginBottom: '1rem',
    color: `${colors.sas.primary}`,
    fontWeight: '700',
  },

  modalDealTitle: {
    marginTop: '0 !important',
    marginBottom: '0 !important',
    margin: '0.5rem 0 !important',
  },

  modalDealDescription: {
    marginBottom: '1rem',
  },

  modalDealImage: {
    width: '100%',
    height: 'auto',
  },

  contentRight: {
    justifyContent: 'flex-start',

    [media.l.up]: {
      justifyContent: 'center',
    },

    '> *': {
      textAlign: 'center !important',
      marginBottom: '1rem',
    },
  },

  ctaHeading: {
    fontSize: '1.5rem',
  },

  ctaExcerpt: {
    fontWeight: '700',
  },

  ctaDescription: {
    padding: `${scale.m} ${scale.s} 0 ${scale.s}`,
    backgroundColor: colors.light_grey,
  },

  ctaButton: {
    margin: `${scale.m}`,
  },

  memberPhone: {},
});
